import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { Can } from "@/components/citadel";
import { AddContactBankAccountModal } from "@/modals/contacts/add-contact-bank-account-modal";

/** Props Interface */
interface ContactBankAccountsMenuProps {
	contactId: string;
}

export function ContactBankAccountsMenu({ contactId }: ContactBankAccountsMenuProps) {
	/** Context */
	const { t } = useTranslation();

	/** Hooks */
	const addModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<Can
				action="update"
				subject="Contact"
			>
				<Button
					variant="primary"
					icon={<Icon name="Plus" />}
					onClick={addModal.onOpen}
					data-cy="add-contact-bank-account-button"
				>
					{t("contacts.bank_accounts.add")}
				</Button>
			</Can>
			{addModal.isOpen && (
				<AddContactBankAccountModal
					isOpen={addModal.isOpen}
					onClose={addModal.onClose}
					contactId={contactId}
				/>
			)}
		</React.Fragment>
	);
}
